import React from 'react';
import styled from "styled-components";
import CheckableOption from './CheckableOption';
import WithCounterChoiceOption from "./WithCounterChoiceOption";
import OptionGroup from "./OptionGroup";

const Container = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

const OptionsAdd = ({ options, ...props}) => {
    const { pricesDependOn, pathInDataState } = props;

    return (
        <Container>
            {
                options.map((option, index) => (
                    <React.Fragment key={index}>
                        {
                            'checkable' === option.type && (
                                <CheckableOption
                                    dependsOn={pricesDependOn}
                                    pathInDataState={pathInDataState}
                                    pathInDataStateQuantity={option.pathInDataStateQuantity}
                                    name={option.name}
                                    image={option.image}
                                    label={option.label}
                                    tarifsName={option.name}
                                    counterLabel={option.counterLabel}
                                    counterDependsOn={option.counterDependsOn}
                                    full={option.full}
                                    fullOptions={option.fullOptions}
                                    setItselfFalse={option.setItselfFalse}
                                    setInDataState={option.setInDataState}
                                    default={option.default}
                                    disabled={option.disabled}
                                />
                            )
                        }
                        {
                            'group' === option.type && (
                                <OptionGroup
                                    dependsOn={pricesDependOn}
                                    partOfId={pricesDependOn}
                                    pathInDataState={pathInDataState}
                                    {...option}
                                />
                            )
                        }
                        {
                            'withChoice' === option.type && (
                                <WithCounterChoiceOption
                                    hektorOffer={pricesDependOn ?? option.pricesDependOn}
                                    partOfId={pricesDependOn}
                                    pathInDataState={pathInDataState}
                                    {...option}
                                />
                            )
                        }
                    </React.Fragment>
                ))
            }
        </Container>
    );
}

export default OptionsAdd;
